import React from 'react';
import { SaneImage } from '../../sanity/sane-image';

type TClerkComponentsHeroProps = {
  heroTitle: string;
  heroDesc: string;
  heroImage: string;
};

export const ClerkComponentsHero: React.FC<TClerkComponentsHeroProps> = ({
  heroTitle,
  heroDesc,
  heroImage
}) => (
  <div>
    <div className="relative flex flex-col items-center px-4 py-12 mx-auto overflow-hidden max-w-7xl sm:px-6 lg:pt-16 lg:pb-24 lg:px-8">
      <h2 className="mb-2 text-base font-semibold leading-6 tracking-wide uppercase text-clerk-blue">
        Clerk Component
      </h2>
      <h1 className="text-4xl font-extrabold leading-10 tracking-tight text-center text-gray-900 ">
        {heroTitle}
      </h1>

      <p className="mt-8 tracking-normal block max-w-[460px] text-lg font-normal leading-7 text-center text-gray-500 mb-12">
        {heroDesc}
      </p>

      {heroImage && (
        <SaneImage
          wrapClassName="drop-shadow-clerk-components filter"
          className="rounded-3xl"
          src={heroImage}
        />
      )}
    </div>
  </div>
);
